import { render, staticRenderFns } from "./SimpleListPage.vue?vue&type=template&id=9c2c34a6&"
import script from "./SimpleListPage.vue?vue&type=script&lang=js&"
export * from "./SimpleListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports